// ============================================================================
// NOTICE TEMPLATE ENDPOINTS
// ============================================================================
// BASE_PATH must match backend NoticeTemplateController → /NoticeTemplate.

import { buildEndpoint, buildEndpointWithParams } from './base.endpoints';
import type { ID } from '../types';

export const NOTICE_TEMPLATE_BASE_PATH = '/NoticeTemplate';

export const noticeTemplateEndpoints = {
  list: () => buildEndpoint(NOTICE_TEMPLATE_BASE_PATH),
  getById: (id: ID) => buildEndpointWithParams(`${NOTICE_TEMPLATE_BASE_PATH}/:id`, { id }),
  getByCode: (code: string) => buildEndpointWithParams(`${NOTICE_TEMPLATE_BASE_PATH}/code/:code`, { code }),
  create: () => buildEndpoint(NOTICE_TEMPLATE_BASE_PATH),
  update: (id: ID) => buildEndpointWithParams(`${NOTICE_TEMPLATE_BASE_PATH}/:id`, { id }),
  delete: (id: ID) => buildEndpointWithParams(`${NOTICE_TEMPLATE_BASE_PATH}/:id`, { id }),
  validateCode: (code: string) => buildEndpointWithParams(`${NOTICE_TEMPLATE_BASE_PATH}/validate/code/:code`, { code }),
  preview: () => buildEndpoint(`${NOTICE_TEMPLATE_BASE_PATH}/preview`),
} as const;

export default noticeTemplateEndpoints;
